import { toast } from '../hooks/use-toast';

class NotificationService {
  // Success notifications
  success(message, description = null) {
    toast({
      title: '🍕 Success!',
      description: message,
      variant: 'default',
    });
  }

  // Error notifications
  error(message, description = null) {
    toast({
      title: '❌ Error',
      description: message,
      variant: 'destructive',
    });
  }

  // Info notifications
  info(message, description = null) {
    toast({
      title: 'ℹ️ Info',
      description: message,
    });
  }

  // Warning notifications
  warning(message, description = null) {
    toast({
      title: '⚠️ Warning',
      description: message,
    });
  }

  // Auth-specific notifications
  authSuccess(action) {
    const messages = {
      login: 'Welcome back! You\'re now logged in.',
      register: 'Account created successfully! Welcome to Kinora!',
      logout: 'You\'ve been logged out successfully.',
    };

    this.success(messages[action] || 'Authentication successful');
  }

  authError(action, error) {
    const defaultMessages = {
      login: 'Login failed. Please check your credentials.',
      register: 'Registration failed. Please try again.',
      logout: 'Logout failed. Please try again.',
    };

    const message = error?.message || defaultMessages[action] || 'Authentication failed';
    this.error(message);
  }

  // Network error handler
  networkError() {
    this.error('Network error. Please check your connection and try again.');
  }

  // Validation error handler
  validationError(message) {
    this.warning(message || 'Please check your input and try again.');
  }
}

export const notificationService = new NotificationService();
export default notificationService;